if (!customElements.get("new-bundle")) {
  customElements.define(
    "new-bundle",
    class NewBundle extends HTMLElement {
      constructor() {
        super();
        this.offers = this.querySelectorAll(".new-bundle-offer--container");
        this.variants = this.querySelectorAll(".new-bundle--variant");
        this.limitCount = 0;
        this.limit = parseInt(this.querySelector(".new-bundle-offer--container.new-bundle-offer--container__active").dataset.quantity, 10);
        this.form = this.querySelector("form");
        this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButton.disabled = true;
        if (document.querySelector("cart-drawer")) this.submitButton.setAttribute("aria-haspopup", "dialog");
        this.colorsPicked = [];

        this.defaultImgSrc = this.querySelector('.new-bundle-offer--image').src;
        this.defaultImgAlt = this.querySelector('.new-bundle-offer--image').alt;
      }
      connectedCallback() {
        this.offers.forEach((offer) => {
          if (offer.classList.contains("new-bundle-offer--container__active")) this.updateMainPriceContainer(offer);
          offer.addEventListener("click", this.onOfferClick.bind(this));
        });
        this.variants.forEach((variant) => {
          variant.addEventListener("click", this.onVariantClick.bind(this));
        });
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
      }

      onOfferClick(evt) {
        if (evt.currentTarget.classList.contains("new-bundle-offer--container__active")) return;
        this.offers.forEach((offer) => {
          offer.classList.remove("new-bundle-offer--container__active");
        });
        evt.currentTarget.classList.add("new-bundle-offer--container__active");
        const newLimit = parseInt(evt.currentTarget.dataset.quantity, 10);
        // this.updateColorsOnOfferChange(newLimit);
        this.limit = newLimit;
        this.updateButtonStateAndContent(this.limit, this.limitCount);
        this.updateMainPriceContainer(evt.currentTarget);
        this.clearColors();

        this.querySelectorAll(".new-bundle--variant").forEach((variant) => {
          if (variant.dataset.offerIndex === evt.currentTarget.dataset.offerIndex) {
            variant.style.display = "block";
          } else {
            variant.style.display = "none";
          }
        });

        this.updateLegend(this.limit, 0);
      }

      onVariantClick(evt) {
        this.selectColor(evt.currentTarget);
      }
      selectColor(variant) {
        var qtyLabel = variant.querySelector(".new-bundle--variant__selected-number");
        if (variant.dataset.method == "increment") {
          variant.dataset.quantity++;
          this.limitCount++;
          variant.dataset.index = this.limitCount;
          this.colorsPicked.push({ id: variant.dataset.id, position: parseInt(this.limitCount, 10) });
          this.updateImagesInOffer(variant);
        } else {
          variant.dataset.quantity--;
          this.limitCount--;
          this.colorsPicked = this.colorsPicked.filter(
            (color) => color.id != variant.dataset.id && color.position != parseInt(variant.dataset.index, 10),
          );
          this.colorsPicked.forEach((color, index) => {
            color.position = index + 1;
          });
          if (variant.dataset.quantity == 0) variant.dataset.method = "increment";
        }

        this.updateQuantityLabel(variant, qtyLabel);
        this.updateVariantState(variant, qtyLabel);

        switch (this.limitCount) {
          case this.limit:
            this.querySelectorAll(".new-bundle--variant__active").forEach((variant) => {
              variant.dataset.method = "decrement";
            });
            this.querySelectorAll(".new-bundle--variant:not(.new-bundle--variant__active)").forEach((variant) => {
              variant.classList.add("new-bundle--variant__disabled");
            });
            break;
          case 0:
            this.querySelectorAll(".new-bundle--variant").forEach((variant) => {
              variant.dataset.method = "increment";
            });
            this.querySelectorAll(".new-bundle--variant:not(.new-bundle--variant__active)").forEach((variant) => {
              variant.classList.remove("new-bundle--variant__disabled");
            });
            break;

          default:
            document.querySelectorAll(".new-bundle--variant:not(.new-bundle--variant__active)").forEach((variant) => {
              variant.classList.remove("new-bundle--variant__disabled");
            });
            break;
        }
        this.updateLegend(this.limit, this.limitCount);
        this.updateButtonStateAndContent(this.limit, this.limitCount);
      }
      updateQuantityLabel(variant, qtyLabel) {
        qtyLabel.innerHTML = variant.dataset.quantity;
        qtyLabel.style.visibility = "visible";
        if (parseInt(qtyLabel.innerHTML) === 0) qtyLabel.style.visibility = "hidden";
      }
      updateVariantState(variant, qtyLabel) {
        variant.classList.add("new-bundle--variant__active");
        if (parseInt(qtyLabel.innerHTML) === 0) variant.classList.remove("new-bundle--variant__active");
      }

      updateLegend(limit, limitCount) {
        let nearLimit = limit - 1;
        if (limitCount === limit) {
          let selectedColors = [];
          this.querySelectorAll(".new-bundle--variant__active").forEach((variant) => {
            for (let i = 0; i < variant.dataset.quantity; i++) {
              selectedColors.push(variant.dataset.name);
            }
          });
          let selectedColorsString = selectedColors.join(" x ");
          document.querySelector(".new-bundle--variant-picker__legend legend").innerText = "🎉 Sélection : " + selectedColorsString;
        } else if (limitCount === nearLimit) {
          document.querySelector(".new-bundle--variant-picker__legend legend").innerText = "Plus qu'une couleur à choisir :";
        } else {
          document.querySelector(".new-bundle--variant-picker__legend legend").innerText = "Je choisis mes couleurs :";
        }
      }

      updateButtonStateAndContent(limit, limitCount) {
        const btnTextContainer = this.submitButton.querySelector("span");
        let nearLimit = limit - 1;
        if (limitCount === limit) {
          let selectedColors = [];
          this.querySelectorAll(".new-bundle--variant__active").forEach((variant) => {
            for (let i = 0; i < variant.dataset.quantity; i++) {
              selectedColors.push(variant.dataset.name);
            }
          });
          this.submitButton.disabled = false;
          btnTextContainer.innerText = window.variantStrings.addToCart;
        } else if (limitCount === nearLimit) {
          this.submitButton.disabled = true;
          btnTextContainer.innerText = "Plus qu'une couleur à choisir";
        } else {
          this.submitButton.disabled = true;
          btnTextContainer.innerText = "Je choisis mes couleurs";
        }
      }

      updateMainPriceContainer(offer) {
        const offerPrice = offer.dataset.price;
        const offerComparePrice = offer.dataset.comparePrice;
        const closestSection = this.closest(".section");
        const mainPriceContainer = closestSection.querySelector(".price__container");
        const regularPrice = mainPriceContainer.querySelector(".price__regular .price-item--regular");
        regularPrice.innerText = offerComparePrice;
        const saleRegularPrice = mainPriceContainer.querySelector(".price__sale .price-item--regular");
        saleRegularPrice.innerText = offerComparePrice;
        const salePrice = mainPriceContainer.querySelector(".price__sale .price-item--sale");
        salePrice.innerText = offerPrice;
      }

      updateImagesInOffer(variant) {
        this.offers.forEach((offer) => {
          const offerImages = offer.querySelectorAll(".new-bundle-offer--image");
          offerImages.forEach((image, index) => {
            if (index == variant.dataset.index - 1) {
              image.src = variant.dataset.img;
              image.alt = variant.dataset.name;
            }
          });
        });
      }

      clearColors() {
        this.limitCount = 0;
        this.colorsPicked = [];

        this.querySelectorAll(".new-bundle--variant").forEach((variant) => {
          variant.querySelector(".new-bundle--variant__selected-number").style.visibility = "hidden";

          variant.classList.remove("new-bundle--variant__disabled");
          variant.classList.remove("new-bundle--variant__active");

          variant.dataset.quantity = 0;
          variant.dataset.method = "increment";
        });

        this.querySelectorAll('.new-bundle-offer--image').forEach((img) => {
          img.src = this.defaultImgSrc;
          img.alt = this.defaultImgAlt;
        });
      }

      updateColorsOnOfferChange(newLimit) {
        if (this.limitCount < newLimit) {
          this.querySelectorAll(".new-bundle--variant").forEach((variant) => {
            variant.classList.remove("new-bundle--variant__disabled");
          });
          this.querySelectorAll(".new-bundle--variant__active").forEach((variant) => {
            variant.dataset.method = "increment";
          });
        } else if (this.limitCount == newLimit) {
          this.querySelectorAll(".new-bundle--variant:not(.new-bundle--variant__active)").forEach((variant) => {
            variant.classList.add("new-bundle--variant__disabled");
          });
          this.querySelectorAll(".new-bundle--variant__active").forEach((variant) => {
            variant.dataset.method = "decrement";
          });
        } else {
          const nbOfVariantsToRemove = this.limitCount - newLimit;
          // Triez les objets dans this.colorsPicked en fonction de leur position
          const sortedColors = this.colorsPicked.sort((a, b) => b.position - a.position);

          // Retirez la classe "new-bundle--variant__active" des variants en fonction du nombre spécifié
          for (let i = 0; i < nbOfVariantsToRemove && i < sortedColors.length; i++) {
            const idToRemove = sortedColors[i].id;
            this.colorsPicked = this.colorsPicked.filter((color) => color.id != idToRemove);

            // Recherchez le variant avec le data-id correspondant
            const variantToRemoveClass = this.querySelector(`.new-bundle--variant[data-id="${idToRemove}"]`);

            // Assurez-vous que le variant a été trouvé avant de retirer la classe
            if (variantToRemoveClass) {
              if (variantToRemoveClass.dataset.quantity == 1) {
                variantToRemoveClass.classList.remove("new-bundle--variant__active");
                variantToRemoveClass.dataset.quantity = 0;
                variantToRemoveClass.dataset.method = "increment";
                variantToRemoveClass.classList.add("new-bundle--variant__disabled");
              } else {
                variantToRemoveClass.dataset.quantity--;
              }
              this.updateLegend(newLimit, this.limitCount - nbOfVariantsToRemove);
              this.updateQuantityLabel(variantToRemoveClass, variantToRemoveClass.querySelector(".new-bundle--variant__selected-number"));
              this.updateButtonStateAndContent(newLimit, this.limitCount - nbOfVariantsToRemove);
            }
          }
          this.limitCount = this.limitCount - nbOfVariantsToRemove;

          this.querySelectorAll(".new-bundle--variant__active").forEach((variant) => {
            variant.dataset.method = "decrement";
          });
        }
      }

      addSelectedBundleToFormInputs() {
        document.querySelector("#insertBundleInputsHere").innerHTML = "";
        const idsArray = [];
        document.querySelectorAll(".new-bundle--variant__active").forEach((variant, index) => {
          const id = variant.dataset.id;
          const quantity = parseInt(variant.dataset.quantity, 10);
          idsArray.push(id);
          const value = document.createElement("div");
          value.innerHTML = `<input id="bundleProductIdInput-${index}" type="hidden" name="items[${index}][id]" value="${id}">`;
          const qty = document.createElement("div");
          if (quantity != null) {
            qty.innerHTML = `<input id="bundleProductIdInput-${index}" type="hidden" name="items[${index}][quantity]" value="${quantity}">`;
          } else {
            if (idsArray.filter((item) => item == id).length <= 2) {
              qty.innerHTML = `<input id="bundleProductIdInput-${index}" type="hidden" name="items[${index}][quantity]" value="1">`;
            } else {
              qty.innerHTML = `<input id="bundleProductIdInput-${index}" type="hidden" name="items[${index}][quantity]" value="${idsArray.filter((item) => item == id).length - 1
                }">`;
            }
          }
          document.querySelector("#insertBundleInputsHere").appendChild(value);
          document.querySelector("#insertBundleInputsHere").appendChild(qty);
        });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        this.addSelectedBundleToFormInputs();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty")) this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add("hidden");
            if (this.submitButton.dataset.dynamicCheckout == "true") {
              window.location.href = "/checkout";
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}
